module.exports = __webpack_public_path__ + "static/media/demo_cover_image.7c100d09.png";